module.exports = __webpack_public_path__ + "static/media/more.ff69fdd4.svg";